module.exports = __webpack_public_path__ + "static/media/rapidNaming-intro3.8f82d742.mp3";